module.exports = __webpack_public_path__ + "static/media/combustivel-bg.dcf5cc65.jpg";